import clsx from 'clsx'

const UserIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className)}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.8346 17.5V15.8333C15.8346 14.9493 15.4834 14.1014 14.8583 13.4763C14.2332 12.8512 13.3854 12.5 12.5013 12.5H7.5013C6.61725 12.5 5.7694 12.8512 5.14428 13.4763C4.51916 14.1014 4.16797 14.9493 4.16797 15.8333V17.5'
      stroke='currentColor'
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.0013 9.16667C11.8423 9.16667 13.3346 7.67428 13.3346 5.83333C13.3346 3.99238 11.8423 2.5 10.0013 2.5C8.16035 2.5 6.66797 3.99238 6.66797 5.83333C6.66797 7.67428 8.16035 9.16667 10.0013 9.16667Z'
      stroke='currentColor'
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default UserIcon
